import React, { useState } from "react";
import { Modal, TextField, MenuItem, Button } from "@mui/material";

const roleOptions = ["Admin", "HR", "Recruiter", "Manager", "Interviewer","Associate"];

const UserModal = ({ open, onClose, onSubmit, initialData = {}, loading }) => {
  const [form, setForm] = useState({
    name: initialData.name || "",
    email: initialData.email || "",
    role: initialData.role || "",
  });
  const [error, setError] = useState({ name: "", email: "", role: "" });


  // Validate a single field
  const validateField = (name, value) => {
    let errorMsg = "";
    if (name === "name") {
      if (!value.trim()) errorMsg = "Name is required";
    } else if (name === "email") {
      if (!value.trim()) errorMsg = "Email is required";
      else if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(value)) errorMsg = "Invalid email";
    } else if (name === "role") {
      if (!value) errorMsg = "Role is required";
    }
    return errorMsg;
  };

  // Validate all fields (for submit)
  const validateForm = () => {
    const errors = {
      name: validateField("name", form.name),
      email: validateField("email", form.email),
      role: validateField("role", form.role),
    };
    setError(errors);
    return !errors.name && !errors.email && !errors.role;
  };

  // Validate on change
  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
    setError((prev) => ({ ...prev, [name]: validateField(name, value) }));
  };

  const handleSubmit = () => {
    if (!validateForm()) return;
    onSubmit(form);
  };

  return (
    <Modal open={open} onClose={onClose}>
      <div
        style={{
          background: "#fff",
          padding: 32,
          borderRadius: 8,
          maxWidth: 500,
          margin: "100px auto",
          display: "flex",
          flexDirection: "column",
          gap: 16,
        }}
      >
        <h2>{initialData && initialData.id ? "Edit User" : "Invite User"}</h2>
        <TextField
          label="Name"
          name="name"
          value={form.name}
          onChange={handleChange}
          error={!!error.name}
          helperText={error.name}
          fullWidth
          sx={{
            "& .MuiOutlinedInput-root": {
              borderRadius: "8px",
            },
            "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline":
              {
                border: "1px solid #000000",
              },
            "& .MuiInputLabel-root, & .MuiFormLabel-root": {
              color: "#808080",
            },
            "& .MuiInputLabel-root.Mui-focused": {
              color: "#808080",
            },
          }}
        />
        <TextField
          label="Email"
          name="email"
          value={form.email}
          onChange={handleChange}
          error={!!error.email}
          helperText={error.email}
          fullWidth
          sx={{
            "& .MuiOutlinedInput-root": {
              borderRadius: "8px",
            },
            "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline":
              {
                border: "1px solid #000000",
              },
            "& .MuiInputLabel-root, & .MuiFormLabel-root": {
              color: "#808080",
            },
            "& .MuiInputLabel-root.Mui-focused": {
              color: "#000000",
            },
          }}
        />
        <TextField
          select
          label="Role"
          name="role"
          value={form.role}
          onChange={handleChange}
          error={!!error.role}
          helperText={error.role}
          fullWidth
          sx={{
            "& .MuiOutlinedInput-root": {
              borderRadius: "8px",
            },
            "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline":
              {
                border: "1px solid #000000",
              },
            "& .MuiInputLabel-root, & .MuiFormLabel-root": {
              color: "#808080",
            },
            "& .MuiInputLabel-root.Mui-focused": {
              color: "#000000",
            },
          }}
        >
          {roleOptions.map((role) => (
            <MenuItem key={role} value={role}>
              {role}
            </MenuItem>
          ))}
        </TextField>
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            gap: 12,
            marginTop: 16,
          }}
        >
          <Button
            class="cancel-button mw-100"
            onClick={onClose}
            disabled={loading}
          >
            Cancel
          </Button>
          <Button
            class="credit-button"
            variant="contained"
            onClick={handleSubmit}
            disabled={loading}
          >
            Submit
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default UserModal;
